import * as React from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, InputAdornment, InputLabel, Link, OutlinedInput, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { defaultApiCall, userLogin } from '../../redux/Actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingPage } from '../../common/LoadingPage';
import { showNotification } from '../../common/Notification/ToastifyNotification';
import { Lock, Person } from '@mui/icons-material';
import { apiRequest } from '../../common/common';

const DemoPaper = styled(Paper)(({ theme }) => ({
    width: 550,
    height: 'auto',
    padding: '0px 0px 25px 0px',
    margin: 'auto',
    border: '1px solid lightgray'
}));

export default function Login() {
    const dispatch = useDispatch();
    const { loading, error, message, isAuthenticated } = useSelector((state) => state.users);
    const [email, setEmail] = React.useState(null);
    const [password, setPassword] = React.useState(null);
    const [showPassword, setShowPassword] = React.useState(false);
    const [forgotOpen, setForgot] = React.useState(false);
    const [errors, setErrors] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    React.useEffect(() => {
        if (error) {
            showNotification(error, 'error');
        }
        if (message) {
            showNotification(message, 'success');
            dispatch(defaultApiCall());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, message]);

    return (
        <>
            {(loading || isLoading) && (<LoadingPage isLoading={loading || isLoading} />)}
            <Dialog open={forgotOpen} maxWidth="sm">
                <DialogTitle>Forgot Password</DialogTitle>
                <DialogContent>
                    <DemoPaper variant="elevation" style={{ padding: '0px 0px 10px 0px' }}>
                        <Box style={{ display: 'flex', justifyContent: 'end', padding: '10px 0px' }}>
                            <img src="/images/Logo.png" alt='logo' style={{ width: '30%' }} />
                        </Box>
                        <Divider />
                        <Grid container pl={2} pr={2} spacing={1} mt={1}>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Email</InputLabel>
                                    <OutlinedInput
                                        id="standard-adornment-password"
                                        type='text'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        label="Email"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12} display="flex" justifyContent="end">
                                <Button
                                    size="Medium"
                                    variant="contained"
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        setForgot(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    size="Medium"
                                    variant="contained"
                                    onClick={async () => {
                                        setIsLoading(true);
                                        try {
                                            const response = await apiRequest('post', '/forgot-password', {
                                                email: email,
                                            });
                                            if (response.data) {
                                                showNotification(response?.data?.message, 'success')
                                            }
                                            setForgot(false);
                                            setIsLoading(false);
                                        } catch (error) {
                                            showNotification(error?.response?.data.error || error.message, 'error');
                                            setForgot(false);
                                            setIsLoading(false);
                                        }
                                    }}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </DemoPaper>
                </DialogContent>
            </Dialog >
            {!isAuthenticated && (
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
                    <Grid item xs={12} md={6}>
                        <DemoPaper variant="elevation">
                            <Box style={{ display: 'flex', justifyContent: 'end', padding: '10px 0px' }}>
                                <img src="/images/Logo.png" alt='logo' style={{ width: '30%' }} />
                            </Box>
                            <Divider />
                            <Grid container pl={2} pr={2} spacing={1} mt={1}>
                                <Grid item sm={12} md={12}>
                                    <FormControl size="small" fullWidth variant="outlined">
                                        {/* <InputLabel htmlFor="standard-adornment-password">Email</InputLabel> */}
                                        <OutlinedInput
                                            id="standard-adornment-password"
                                            label=""
                                            type='text'
                                            value={email}
                                            placeholder='Email'
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                                const newErrors = errors;
                                                if (!e.target.value) {
                                                    newErrors.email = 'Please enter email';
                                                } else if (!/\S+@\S+\.\S+/.test(e.target.value)) {
                                                    newErrors.email = 'Email is invalid';
                                                } else {
                                                    newErrors.email = '';
                                                }
                                                setErrors(newErrors);
                                            }}
                                            startAdornment={<InputAdornment position="start">
                                                <Person />
                                            </InputAdornment>}
                                        />
                                        <Typography variant='body2' style={{ color: 'red' }}>{errors.email}</Typography>
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={12}>
                                    <FormControl size="small" fullWidth variant="outlined">
                                        <OutlinedInput
                                            label=""
                                            id="standard-adornment-password"
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            placeholder='Password'
                                            autoComplete="new-password"
                                            onChange={(e) => {
                                                setPassword(e.target.value);
                                                const newErrors = errors;
                                                if (e.target.value) {
                                                    newErrors.password = '';
                                                } else {
                                                    newErrors.password = 'Please enter password';
                                                }
                                                setErrors(newErrors);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    const newErrors = {};
                                                    if (!email) {
                                                        newErrors.email = 'Please enter email';
                                                    }
                                                    if (!password) {
                                                        newErrors.password = 'Please enter password';
                                                    }

                                                    setErrors(newErrors);
                                                    sessionStorage.removeItem('reloaded');
                                                    if (Object.keys(newErrors).length === 0) {
                                                        dispatch(userLogin({
                                                            email,
                                                            password
                                                        }));
                                                    }
                                                }
                                            }}
                                            startAdornment={<InputAdornment position="start">
                                                <Lock />
                                            </InputAdornment>}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label={
                                                            showPassword ? 'hide the password' : 'display the password'
                                                        }
                                                        onClick={handleClickShowPassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        <Typography variant='body2' style={{ color: 'red' }}>{errors.password}</Typography>
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={12} display="flex" justifyContent="end" alignItems="center">
                                    <Link href="#" onClick={() => setForgot(true)}>Forgot Password</Link>
                                </Grid>
                                <Grid item sm={12} md={12}>
                                    <center>
                                        <Button
                                            color='primary'
                                            size="Medium"
                                            variant='contained'
                                            onClick={() => {
                                                const newErrors = {};
                                                if (!email) {
                                                    newErrors.email = 'Please enter email';
                                                }
                                                if (!password) {
                                                    newErrors.password = 'Please enter password';
                                                }
                                                sessionStorage.removeItem('reloaded');
                                                setErrors(newErrors);
                                                if (Object.keys(newErrors).length === 0) {
                                                    dispatch(userLogin({
                                                        email,
                                                        password
                                                    }));
                                                }
                                            }}
                                        >
                                            Login
                                        </Button>
                                    </center>
                                </Grid>
                                <Grid item sm={12} md={12} display="flex" justifyContent="center" alignItems="center">
                                    <Typography variant="body2">Don't have an account yet? <Link href="http://mvedas.com/contact.html" target="_blank">Click here</Link></Typography>
                                </Grid>
                            </Grid>
                        </DemoPaper>
                    </Grid>
                </Grid>
            )
            }
        </>
    );
}